import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/ui/page'

import { productDetail } from '@/features/product/api'
import { ProductUpdateForm } from '@/features/product/components/product-form'

export const Route = createFileRoute('/_app/product/$id/update')({
	loader: async ({ context: { qc }, params }) => {
		const { id } = params
		await qc.ensureQueryData(productDetail.qry({ id }))
	},
	component: Component,
})

function Component() {
	const { id } = Route.useParams()
	const { product } = useSuspenseQuery(productDetail.qry({ id })).data

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/product', 'Produk'],
					['/product/$id', product.name],
					['/product/$id/edit', 'Edit'],
				]}
			/>
			<ProductUpdateForm />
		</PageLayout.Root>
	)
}
